import React from 'react';

export interface FAQItem {
  question: string;
  answer: string;
}

interface FAQProps {
  title?: string;
  faqs: FAQItem[];
}

export function FAQ({ title = 'Frequently asked questions', faqs }: FAQProps) {
  return (
    <section className="bg-white section-padding">
      <div className="container-page">
        <h2 className="heading-1 text-[--clinqr-navy] text-center mb-12">{title}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8 max-w-4xl mx-auto">
          {faqs.map((faq, index) => (
            <div key={index}>
              <h3 className="heading-4 text-[--clinqr-navy] mb-2">{faq.question}</h3>
              <p className="text-[--clinqr-navy]/60">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
